import React, { useState } from "react";
import CustomMRTInstance from "./trybz_dashboard/_components/customTables/CustomMRTInstance";
import usePagedQuery from "../../hooks/usePagedQuery";
import { useUserStore } from "../../store/user.store";
import Paginate from "../../utils/helpers/Paginate";
import { AiOutlineMail } from "react-icons/ai";
import { MdOutlinePhone } from "react-icons/md";
import { Badge, Button } from "react-bootstrap";
import ClusterService from "../../services/cluster.service";
import MetricsCard from "./trybz_dashboard/admin/billing&Payments/records/trybz-payement/components/cards/MetricsCard";
import PaymentSideBar from "./trybz_dashboard/admin/billing&Payments/_components/layout/Sidebar";

export default function MRTDEMO(props) {
  const pageSize = 20;
  const searchValue = useUserStore((state) => state.search);
  const [page, setPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [currentLen, setCurrentLen] = useState(1);

  // query for data

  const query = usePagedQuery(["getDEMO", { query: searchValue }], (page) =>
    ClusterService.getClusters({
      page: Number(page + 1),
      pageSize: pageSize,
      estateId: "2abfef9a-9bcc-4e69-a13c-4618dbc70ce2",
      query: searchValue,
    })
  );

  //   async function query() {
  //     return await axiosAuthInstance
  //       .get(`/clusters`, {
  //         params: {
  //         },
  //       })
  //       .then((res) => {
  //         setqueryMembers(res.data);
  //         return res.data;
  //       });
  //   }
  //   useEffect(() => {
  //     query();
  //   }, []);

  const pageCount = query?.result
    ? Math.ceil(query?.result?.totalCount / pageSize)
    : 0;
  const tableHeaders = [
    {
      header: "ID",
      
      
      accessorKey: "code",
    },
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Email",
      accessorKey: "managerEmail",
      Cell: ({ cell }) => (
        <AiOutlineMail size={25} className="tw-ml-2 tw-text-primary-blue" />
      ),
    },
    {
      header: "Phone",
      accessorKey: "managerPhoneNumber",
      Cell: ({ cell }) => (
        <MdOutlinePhone
          size={25}
          className="tw-ml-2 tw-rotate-[135deg] tw-text-primary-blue"
          onClick={() => console.log(cell)
          }
        />
      ),
    },
    {
      header: "Address",
      accessorKey: "location.address",
      Cell: ({ cell }) =>
        cell.row.original?.location?.address === null ||
        cell.row.original?.location?.address === ""
          ? "N/A"
          : cell.getValue(),
    },
    {
      header: "Status",
      accessorKey: "status",
      Cell: ({ cell }) => (
        <Badge
          variant={`${
            cell.getValue() === "active" ? "primary" : "warning"
          }  light rounded-pill tw-capitalize`}
        >
          {cell.getValue()}
        </Badge>
      ),
    },
    //   {
    //     id: "actions",
    //     header: "",
    //     columnDefType: "display", //turns off data column features like sorting, filtering, etc.
    //     Cell: ({ row }) => (
    //       <Dropdown>
    //         <Dropdown.Toggle variant="light" className="i-false sharp btn-xs">
    //           <BsThreeDots className="tw-mx-auto" />
    //         </Dropdown.Toggle>
    //         <Dropdown.Menu>
    //           <Dropdown.Item
    //           // onClick={() => props.editProfile(user.id, user)}
    //           >
    //             View Details
    //           </Dropdown.Item>
    //         </Dropdown.Menu>
    //       </Dropdown>
    //     ),
    //   },
  ];
  // <div className="tw-grid tw-grid-cols-1 tw-gap-2 lg:tw--ml-7 lg:tw--mt-7 lg:tw-grid-cols-8">
  //   <div className=" lg:tw-col-span-2">
  //     <PaymentSideBar />
  //   </div>

  //   <div className=" tw-p-6 lg:tw-col-span-6">

  return (
    <div className="tw-grid tw-grid-cols-1 tw-gap-2 lg:tw--ml-7 lg:tw--mt-7 lg:tw-grid-cols-8">
      <div className=" lg:tw-col-span-2">
        <PaymentSideBar />
      </div>

      <div className=" tw-p-6 lg:tw-col-span-6">
        <div className="form-head d-md-flex mb-sm-4 mb-3 align-items-start">
          <div className="mr-auto  d-lg-block">
            <h2 className="text-black font-w600">Clusters</h2>
          </div>
          <Button className="btn btn-primary custom-bg-primary rounded mr-3">
            Add a Cluster
          </Button>

          <Button className="btn btn-primary rounded light mr-3">
            Refresh
          </Button>
        </div>
        <div className="tw-flex tw-gap-x-12">
          <MetricsCard title="Incoming Payments summary" />
          <MetricsCard title="outgoing Payments summary" />
        </div>
        <CustomMRTInstance
          tableData={query?.result?.items}
          headers={tableHeaders}
          columnVisibility={{ managerEmail: false, managerPhoneNumber: false }}
          paginateComponent={
            query.result.items?.length > 0 ? (
              <>
                {" "}
                <Paginate
                  query={query}
                  page={page}
                  pageCount={pageCount}
                  pageSize={pageSize}
                  setPage={(currentPage) => {
                    query.setPage(currentPage - 1);
                    setPage(currentPage);
                  }}
                  setCurrentLen={setCurrentLen}
                />
              </>
            ) : (
              <div className="d-flex s darkText justify-content-center py-2">
                No data yet
              </div>
            )
          }
        />
        {/* )}{" "} */}
      </div>
    </div>
  );
}
